<ng-template #template>
<button 
  type="button"
  kendoButton
  look="flat"
  [title]="title || text"
  (click)="onClick($event)"
  [icon]="icon"
  [disabled]="disabled"
  [primary]="primary"
  [class.hidden]="hidden"
  >
  {{text | i18n}}
  <ng-content></ng-content>
</button>
</ng-template>
